import {Popconfirm, Tooltip, PopconfirmProps} from "antd";import Icon, { DeleteOutlined } from "@ant-design/icons";
import React from "react";
import {DeleteIcon} from "./DeleteIcon";
import styles from './Delete.module.scss';
import classNames from "classnames";

export type DeleteProps = {
    tooltip: string
    onDelete: PopconfirmProps['onConfirm']
    icon?: "s" | "m"
    className?: string
    text?: string
}

const DeletionIcon = ({icon}: Required<Pick<DeleteProps, "icon">>) => {
    if (icon === "s") {
        return <DeleteOutlined
            style={{ fontSize: '1em', color: '#565656' }}
        />
    }

    return <Icon component={DeleteIcon} className={styles['action']} />
}

export const Delete = ({tooltip, onDelete, className, icon, text}: DeleteProps) => <Popconfirm
    title="Are you sure you want to delete this?"
    onConfirm={onDelete}
    okText="Yes"
    cancelText="No"
    overlayClassName={styles["delete-button"]}
    >
    <Tooltip title={tooltip} zIndex={100}>
        <span className={classNames(styles['delete'], className)}>
            { icon !== undefined ? <DeletionIcon icon={icon}/> : undefined}
            &nbsp;
            { text !== undefined ? <span>Delete</span> : undefined }
        </span>
    </Tooltip>
</Popconfirm>